(ns css.ie11
  (:require
    [oops.core :refer [oset!]]
    ["css-vars-ponyfill" :as css-vars]
    )
  (:require-macros
    [logging.core]
    )
  )

;; when in ie we call swap-vars on each new css rule added. this swap will look
;; for --var declarations in the new rule. if any exist it will append to a ie11
;; style tag those new rules. afterwards the css-vars plugin will run, which
;; looks at all --var references and their corresponding values, then swaps out
;; the refs for the real value, attaching the swapped-out css to the dom. wow.
;; this was the best workaround we could find, aside from swapping out our
;; entire cljss lib (intractable), or some post-compilation processor that
;; might "server side render" all rule declarations into one giant ie11 sheet.
(def re-var-declaration-and-value #"--var-[^:)]+:[^;]+;")
(def re-var-property-and-reference #"([^;:]+):var\(([^\)]+)\)")

;; --var-foo_GENSYM -> "blue"
;; "background-color" -> "--var-foo_GENSYM"
(defn- create-root-style []
  (let [ele (.createElement js/document "style")]
    (.setAttribute ele "id" "ie11-root-style")
    (.setAttribute ele "type" "text/css")
    (oset! ele "innerHTML" ":root {}")
    (.appendChild (.-head js/document) ele)))

(defn- update-root-style [vars]
  (let [ele (.getElementById js/document "ie11-root-style")
        literal (apply str vars)
        prev (.-innerHTML ele)]
    (oset! ele "innerHTML" (str (subs prev 0 (dec (count prev))) literal "}"))))

(defn swap-vars [rule cls-name]
  (let [vars (re-seq re-var-declaration-and-value rule)]
    (when vars
      (update-root-style vars)
      ;; swap out our root styles, our cljss styles, and our themes
      (css-vars (clj->js {"include" "#ie11-root-style,[data-cljss-managed-sheet],#themes"
                          "onlyVars" true
                          "onlyLegacy" false
                          "preserve" true
                          "updateURLs" false
                          "updateDOM" true
                          })))))

(defn polyfill! []
  (logging.core/log "Init ie11 stylesheet polyfill.")
  (create-root-style))
